/* Hapsay bundle builder — pick N colors (via + buttons or by tapping a slot), add them all to cart in one go.
   The bundle price itself comes from an automatic discount in Shopify (see the install guide). */
(function () {
  function money(cents, sym) {
    return sym + (cents / 100).toLocaleString('en-PH', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function init(el) {
    if (el.dataset.hpReady) return;
    el.dataset.hpReady = '1';
    var size = parseInt(el.dataset.size, 10) || 3;
    var bundle = parseInt(el.dataset.bundlePrice, 10) || 0;
    var base = parseInt(el.dataset.basePrice, 10) || 0;
    var sym = el.dataset.currency || '₱';
    var cards = Array.prototype.slice.call(el.querySelectorAll('[data-variant]'));
    var slotEls = Array.prototype.slice.call(el.querySelectorAll('[data-slot]'));
    var picker = el.querySelector('[data-hp-picker]');
    var pickBtns = picker ? Array.prototype.slice.call(picker.querySelectorAll('[data-pick-index]')) : [];
    var pickTitle = picker ? picker.querySelector('[data-hp-picker-title]') : null;
    var removeBtn = picker ? picker.querySelector('[data-hp-picker-remove]') : null;
    var step = el.querySelector('[data-hp-step]');
    var btn = el.querySelector('[data-hp-add]');
    var regularEl = el.querySelector('[data-hp-regular]');
    var saveEl = el.querySelector('[data-hp-save]');
    var err = el.querySelector('[data-hp-error]');

    var slots = slotEls.map(function () { return null; }); /* each slot holds a card index or null */
    var active = -1;

    function count(k) { return slots.filter(function (x) { return x === k; }).length; }
    function total() { return slots.filter(function (x) { return x !== null; }).length; }
    function nextEmpty(from) {
      for (var i = 1; i <= slots.length; i++) { var j = (from + i) % slots.length; if (slots[j] === null) return j; }
      return -1;
    }

    function render() {
      var t = total();
      var left = size - t;
      var full = t >= size;
      cards.forEach(function (card, k) {
        var n = count(k);
        card.classList.toggle('is-picked', n > 0);
        card.querySelector('[data-hp-count]').textContent = n;
        var badge = card.querySelector('[data-hp-badge]');
        badge.hidden = n === 0;
        badge.textContent = '×' + n;
        card.querySelector('[data-hp-minus]').disabled = n === 0;
        card.querySelector('[data-hp-plus]').disabled = full || card.hasAttribute('data-soldout');
      });
      slotEls.forEach(function (slot, i) {
        var k = slots[i];
        var c = k === null ? null : cards[k];
        slot.classList.toggle('is-filled', !!c);
        slot.classList.toggle('is-active', i === active);
        slot.setAttribute('aria-expanded', i === active ? 'true' : 'false');
        var dot = slot.querySelector('[data-hp-dot]');
        dot.style.background = c ? c.dataset.swatch : '';
        dot.textContent = c ? '' : '+';
        slot.querySelector('[data-hp-name]').textContent = c ? c.dataset.name : slot.dataset.empty;
        slot.setAttribute('aria-label', 'Slot ' + (i + 1) + ': ' + (c ? c.dataset.name + ', tap to change' : slot.dataset.empty));
      });
      if (picker) {
        picker.hidden = active < 0;
        if (active >= 0) {
          if (pickTitle) pickTitle.textContent = (slots[active] === null ? 'Choose a color for slot ' : 'Change slot ') + (active + 1);
          if (removeBtn) removeBtn.hidden = slots[active] === null;
          pickBtns.forEach(function (b) { b.setAttribute('aria-pressed', parseInt(b.dataset.pickIndex, 10) === slots[active] ? 'true' : 'false'); });
        }
      }
      var regular = full
        ? slots.reduce(function (a, k) { return a + parseInt(cards[k].dataset.price, 10); }, 0)
        : base;
      if (regularEl) regularEl.textContent = money(regular, sym);
      if (saveEl) saveEl.textContent = money(Math.max(regular - bundle, 0), sym);
      if (step) {
        step.textContent = full
          ? el.dataset.readyText
          : el.dataset.chooseText.replace('[left]', left).replace('[count]', t).replace('[size]', size);
      }
      btn.disabled = !full;
      btn.textContent = full ? el.dataset.addText : el.dataset.moreText.replace('[left]', left);
      if (err) err.hidden = true;
    }

    cards.forEach(function (card, k) {
      card.querySelector('[data-hp-plus]').addEventListener('click', function () {
        var i = slots.indexOf(null);
        if (i < 0 || card.hasAttribute('data-soldout')) return;
        slots[i] = k; active = -1; render();
      });
      card.querySelector('[data-hp-minus]').addEventListener('click', function () {
        var i = slots.lastIndexOf(k);
        if (i < 0) return;
        slots[i] = null; active = -1; render();
      });
    });
    slotEls.forEach(function (slot, i) {
      slot.addEventListener('click', function () {
        active = active === i ? -1 : i;
        render();
        if (active >= 0 && pickBtns.length) {
          var first = pickBtns.filter(function (b) { return !b.disabled; })[0];
          if (first) first.focus();
        }
      });
    });
    pickBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (active < 0) return;
        var from = active;
        slots[from] = parseInt(b.dataset.pickIndex, 10);
        active = nextEmpty(from);
        render();
        var target = active >= 0 ? pickBtns.filter(function (x) { return !x.disabled; })[0] : slotEls[from];
        if (target) target.focus();
      });
    });
    if (removeBtn) removeBtn.addEventListener('click', function () {
      if (active < 0) return;
      var from = active;
      slots[from] = null; active = -1; render();
      slotEls[from].focus();
    });
    var closeBtn = picker ? picker.querySelector('[data-hp-picker-close]') : null;
    if (closeBtn) closeBtn.addEventListener('click', function () { var from = active; active = -1; render(); if (from >= 0) slotEls[from].focus(); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && active >= 0) { var from = active; active = -1; render(); slotEls[from].focus(); }
    });

    btn.addEventListener('click', function () {
      if (total() < size) return;
      var items = [];
      cards.forEach(function (c, k) {
        var n = count(k);
        if (n > 0) items.push({ id: parseInt(c.dataset.variant, 10), quantity: n, properties: { _bundle: el.dataset.bundleName } });
      });
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'We couldn’t add your bundle.');
          window.location.href = root() + 'cart';
        })
        .catch(function (e) {
          if (err) { err.textContent = e.message + ' Try again, or swap a color that may be sold out.'; err.hidden = false; }
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        });
    });

    render();
  }

  function initAll() { document.querySelectorAll('[data-hp-bundle]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();
